import { render, staticRenderFns } from "./NativeDate.vue?vue&type=template&id=209127bb&scoped=true&"
import script from "./NativeDate.vue?vue&type=script&lang=js&"
export * from "./NativeDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209127bb",
  null
  
)

export default component.exports